import styled from "styled-components";

export const Anchor = styled.a`
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;
  height: max-content;
`;
